<template>
  <v-select
    class="custom-select-input"
    :disabled="disabled"
    v-model="educationLevel"
    :items="educationLevelList"
    :label="label"
    item-text="text"
    item-value="id"
    :rules="rules"
    validate-on-blur
    @change="onChange"
    chips
    :hint="hint"
    :persistent-hint="persistentHint"
  />
</template>

<script>
import CommonFieldTooltip from '@/components/tooltip/common-field-tooltip'

import { EducationLevelList } from '@/mixins/education-level-list'

export default {
  components: {
    CommonFieldTooltip
  },
  mixins: [EducationLevelList],
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    value: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false
    },
    rules: {
      type: Array,
      required: false,
      default: () => []
    },
    hint: {
      type: String,
      required: false
    },
    persistentHint: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    educationLevel: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    onChange: function() {
      this.$emit('change')
    }
  }
}
</script>
